/*@ngInject*/
const FormatUtil = function () {

    this.formatAsSelector = function (name) {

        function makeCamelCase(str) {
            return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
                return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
            }).replace(/\s+/g, '');
        }

        if (_.isNil(name)) {
            return '';
        }

        name = name.replace(/`/g, ' ');
        name = name.replace(/~/g, ' ');
        name = name.replace(/!/g, ' ');
        name = name.replace(/@/g, ' ');
        name = name.replace(/#/g, ' ');
        name = name.replace(/\$/g, ' ');
        name = name.replace(/%/g, ' ');
        name = name.replace(/\^/g, ' ');
        name = name.replace(/&/g, ' ');
        name = name.replace(/\*/g, ' ');
        name = name.replace(/\(/g, ' ');
        name = name.replace(/\)/g, ' ');
        name = name.replace(/-/g, ' ');
        name = name.replace(/_/g, ' ');
        name = name.replace(/=/g, ' ');
        name = name.replace(/\+/g, ' ');
        name = name.replace(/\[/g, ' ');
        name = name.replace(/{/g, ' ');
        name = name.replace(/]/g, ' ');
        name = name.replace(/}/g, ' ');
        name = name.replace(/\\/g, ' ');
        name = name.replace(/\|/g, ' ');
        name = name.replace(/;/g, ' ');
        name = name.replace(/:/g, ' ');
        name = name.replace(/'/g, '');
        name = name.replace(/"/g, ' ');
        name = name.replace(/,/g, ' ');
        name = name.replace(/</g, ' ');
        name = name.replace(/\./g, ' ');
        name = name.replace(/>/g, ' ');
        name = name.replace(/\//g, '--');
        name = name.replace(/\?/g, ' ');

        return makeCamelCase(name);
    };
};

angular.module('umCore')
    .service('formatUtil', FormatUtil);
